import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { layout } from 'src/components/base';
import { Card as CardComponent, CardContent } from '@prisjakt/ui/card';

export const SponsoredProductLoader = () => (
  <Card outlined={false}>
    <HaloWrapper>
      <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="50" fill="#000" />
      </svg>
    </HaloWrapper>
    <Content>
      <TextRow $width="90%" />
      <TextRow $width="60%" />
      <TextRow $width="100%" />
      <TextRow $width="30%" />
      <TextRow $width="25%" />
    </Content>
  </Card>
);

const shimmer = css`
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: transparent;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.3) 20%,
      rgba(255, 255, 255, 0.5) 60%,
      rgba(255, 255, 255, 0) 100%
    );
    transform: translateX(-100%);
    animation: ${keyframes`
      0%   { transform: translateX(-100%); }
      100% { transform: translateX(100%); }
    `} 2s infinite;
    content: '';
  }
`;

const Card = styled(CardComponent)`
  height: 100%;
`;

const Content = styled(CardContent)`
  flex: 1 1 auto;
  padding-top: 0;
`;

type TextRowProps = {
  $width: string;
  $height?: string;
};

const TextRow = styled.div<TextRowProps>`
  background-color: rgba(0, 0, 0, 0.05);
  width: ${p => p.$width};
  height: ${p => (p.$height ? p.$height : '1rem')};
  ${shimmer}
`;

const HaloWrapper = styled.div`
  max-height: 140px;
  opacity: 0.05;
  display: flex;
  margin: ${layout.measurements.spacing100} 0;
  justify-content: center;
  position: relative;
  ${shimmer}
`;
